import { Link } from "react-router-dom";
import { Bed, Bath, Users } from "lucide-react";
import { motion } from "framer-motion";

export default function PropertyCard({ p, index = 0 }) {
    return (
        <motion.article
            data-testid={`property-card-${p.id}`}
            className="group"
            initial={{ opacity: 0, y: 42 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "0px 0px -10% 0px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: (index % 3) * 0.09 }}
        >
            <div className="editorial-img aspect-[4/5] bg-surface mb-6 overflow-hidden border border-line-dark">
                <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                />
            </div>
            <div className="eyebrow text-gold mb-2">Boutique short-stay</div>
            <h3 className="font-serif text-2xl md:text-3xl text-cream leading-tight mb-3 group-hover:text-gold transition-colors">
                {p.name}
            </h3>
            <div className="flex items-center gap-5 text-xs uppercase tracking-[0.18em] text-cream/50 font-mono">
                <span className="flex items-center gap-1.5">
                    <Bed size={14} strokeWidth={1.2} />
                    {p.bedrooms} Bed
                </span>
                <span className="flex items-center gap-1.5">
                    <Bath size={14} strokeWidth={1.2} />
                    {p.bathrooms} Bath
                </span>
                <span className="flex items-center gap-1.5">
                    <Users size={14} strokeWidth={1.2} />
                    {p.guests} Guests
                </span>
            </div>
            <div className="hairline my-5 opacity-50" />
            {p.amenities && p.amenities.length > 0 && (
                <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs font-light text-cream/50 mb-4">
                    {p.amenities.slice(0, 4).map((a) => (
                        <span key={a}>· {a}</span>
                    ))}
                </div>
            )}
            <p className="text-sm font-light text-cream/55 leading-relaxed">
                {p.description}
            </p>
            {p.airbnb_url ? (
                <a
                    href={p.airbnb_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-underline inline-block mt-5 text-[12px] uppercase tracking-[0.22em] text-cream hover:text-gold font-mono"
                    data-testid={`property-card-cta-${p.id}`}
                >
                    View on Airbnb →
                </a>
            ) : (
                <Link
                    to="/contact"
                    className="link-underline inline-block mt-5 text-[12px] uppercase tracking-[0.22em] text-cream hover:text-gold font-mono"
                    data-testid={`property-card-cta-${p.id}`}
                >
                    Enquire about hosting →
                </Link>
            )}
        </motion.article>
    );
}
